/**
 * Rampe de couleurs des niveaux, dérivée du logo Elyadata : gris pour ce qui
 * n'est pas déclaré, puis périwinkle, cyan, bleu profond, magenta, et l'encre
 * pour le référent. Six paliers, comme l'échelle de la spec (§4.1) — la
 * maquette n'en montrait que quatre, mais l'échelle validée en séance va de 0 à
 * 5 et c'est elle qui compte.
 */

export type CelluleNiveau = { fond: string; bord: string; libelle: string };

export const COULEURS_NIVEAUX: Record<number, CelluleNiveau> = {
  0: { fond: '#EEF0F4', bord: '#C4CADF', libelle: '0 — never used' },
  1: { fond: '#C4CADF', bord: '#C4CADF', libelle: '1 — basics' },
  2: { fond: '#05BAEE', bord: '#05BAEE', libelle: '2 — supervised' },
  3: { fond: '#004F99', bord: '#004F99', libelle: '3 — autonomous' },
  4: { fond: '#D6007F', bord: '#D6007F', libelle: '4 — advanced' },
  5: { fond: '#1F1F1F', bord: '#1F1F1F', libelle: '5 — reference' },
};

/** Une ligne jamais touchée : ni 0, ni « non concerné ». */
export const CELLULE_NON_REPONDUE: CelluleNiveau = {
  fond: 'transparent',
  bord: '#EEF0F4',
  libelle: 'not answered',
};

/** « Non concerné » : distinct du 0, et distinct de l'absence de réponse. */
export const CELLULE_NON_CONCERNEE: CelluleNiveau = {
  fond: 'repeating-linear-gradient(45deg, #F7F8FA 0 3px, #EEF0F4 3px 6px)',
  bord: '#E6E8EC',
  libelle: 'not applicable',
};

export function celluleDe(niveau: number | null, statut: 'notee' | 'non_concernee' | null): CelluleNiveau {
  if (statut === 'non_concernee') return CELLULE_NON_CONCERNEE;
  if (statut === null || niveau === null) return CELLULE_NON_REPONDUE;
  return COULEURS_NIVEAUX[niveau] ?? CELLULE_NON_REPONDUE;
}

/** Ordre de la légende : les niveaux, puis les deux états sans niveau. */
export const LEGENDE: CelluleNiveau[] = [
  COULEURS_NIVEAUX[0]!,
  COULEURS_NIVEAUX[1]!,
  COULEURS_NIVEAUX[2]!,
  COULEURS_NIVEAUX[3]!,
  COULEURS_NIVEAUX[4]!,
  COULEURS_NIVEAUX[5]!,
  CELLULE_NON_CONCERNEE,
  CELLULE_NON_REPONDUE,
];
